"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * IScoreGolfPlus Development
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: 1.1.56-production
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeeTimeStartTypeToJSON = exports.TeeTimeStartTypeFromJSONTyped = exports.TeeTimeStartTypeFromJSON = exports.TeeTimeStartType = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var TeeTimeStartType;
(function (TeeTimeStartType) {
    TeeTimeStartType["ONE"] = "ONE";
    TeeTimeStartType["TEN"] = "TEN";
    TeeTimeStartType["ONEANDTEN"] = "ONE_AND_TEN";
})(TeeTimeStartType = exports.TeeTimeStartType || (exports.TeeTimeStartType = {}));
function TeeTimeStartTypeFromJSON(json) {
    return TeeTimeStartTypeFromJSONTyped(json, false);
}
exports.TeeTimeStartTypeFromJSON = TeeTimeStartTypeFromJSON;
function TeeTimeStartTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.TeeTimeStartTypeFromJSONTyped = TeeTimeStartTypeFromJSONTyped;
function TeeTimeStartTypeToJSON(value) {
    return value;
}
exports.TeeTimeStartTypeToJSON = TeeTimeStartTypeToJSON;
